import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg, fmtNum } from "@/lib/api";
import { Panel, Th, Td, Empty, btn, field } from "@/components/ui-kit";

export const ReelReportPanel = ({ refreshKey }) => {
  const [f, setF] = useState({ date_from: "", date_to: "", sap_po: "" });
  const [rows, setRows] = useState([]);
  const load = (p = f) => api.get("/reports/reels", { params: p }).then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, [refreshKey]); // eslint-disable-line react-hooks/exhaustive-deps
  const set = (k, v) => { const n = { ...f, [k]: v }; setF(n); load(n); };
  const download = async () => {
    try {
      const r = await api.get("/reports/reels.csv", { params: f, responseType: "blob" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(r.data);
      a.download = "Mondi_Reel_Traceability.csv";
      a.click();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Panel title="Mondi reel traceability" testId="reel-report-panel" className="mt-6" action={<span className="text-xs text-slate-400" data-testid="reel-report-count">{rows.length} reel(s)</span>}>
      <div className="flex flex-wrap items-end gap-3 p-4">
        <label className="text-xs text-slate-400">From<Input type="date" value={f.date_from} onChange={(e) => set("date_from", e.target.value)} className={`mt-1 h-9 w-40 ${field}`} data-testid="reel-report-from" /></label>
        <label className="text-xs text-slate-400">To<Input type="date" value={f.date_to} onChange={(e) => set("date_to", e.target.value)} className={`mt-1 h-9 w-40 ${field}`} data-testid="reel-report-to" /></label>
        <label className="text-xs text-slate-400">SAP PO<Input value={f.sap_po} onChange={(e) => set("sap_po", e.target.value)} placeholder="Any" className={`mt-1 h-9 w-44 ${field}`} data-testid="reel-report-sap-po" /></label>
        <Button onClick={download} className={`ml-auto ${btn.primary}`} data-testid="reel-report-download-btn"><Download className="mr-1.5 h-4 w-4" /> Download CSV</Button>
      </div>
      {rows.length ? (
        <div className="max-h-96 overflow-auto">
          <table className="w-full whitespace-nowrap" data-testid="reel-report-table">
            <thead className="border-b border-slate-800"><tr><Th>Reel ID</Th><Th>SAP PO</Th><Th>Call-off</Th><Th>Ship date</Th><Th>Part</Th><Th>Grade</Th><Th>Qty</Th><Th>From</Th><Th>BOL</Th></tr></thead>
            <tbody className="divide-y divide-slate-800/70">
              {rows.map((r, i) => (
                <tr key={`${r.calloff_no}-${r.reel}-${i}`} data-testid={`reel-row-${r.reel}`}>
                  <Td className="font-mono text-slate-100">{r.reel}</Td>
                  <Td className="font-mono">{r.sap_po || "—"}</Td>
                  <Td className="font-mono">{r.calloff_no}</Td>
                  <Td>{r.ship_date || r.received || "—"}</Td>
                  <Td className="font-mono">{r.part_no}</Td>
                  <Td>{r.grade}</Td>
                  <Td className="font-mono">{r.qty === "" ? "—" : `${fmtNum(r.qty)} ${r.uom}`}</Td>
                  <Td className="font-mono">{r.site}</Td>
                  <Td className="font-mono">{r.bol || "—"}</Td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : <Empty testId="reel-report-empty">No reels received for these filters.</Empty>}
    </Panel>
  );
};
